import { render, staticRenderFns } from "./UploadBtiDialog.vue?vue&type=template&id=80326ad0&lang=pug&"
import script from "./UploadBtiDialog.vue?vue&type=script&lang=js&"
export * from "./UploadBtiDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports